{
  "Accessibility Menu": "Tilgjengelighetsmeny",
  "Reset settings": "Tilbakestill innstillinger",
  "Close": "Lukk",
  "Content Adjustments": "Innholdstilpasninger",
  "Adjust Font Size": "Juster skriftstørrelse",
  "Highlight Title": "Fremhev tittel",
  "Highlight Links": "Fremhev lenker",
  "Readable Font": "Lesbar skrifttype",
  "Color Adjustments": "Fargejusteringer",
  "Dark Contrast": "Mørk kontrast",
  "Light Contrast": "Lys kontrast",
  "High Contrast": "Høy kontrast",
  "High Saturation": "Høy metning",
  "Low Saturation": "Lav metning",
  "Monochrome": "Monokrom",
  "Contrast": "Kontrast",
  "Invert Colors": "Inverter farger",
  "Tools": "Verktøy",
  "Reading Guide": "Leseguide",
  "Stop Animations": "Stopp animasjoner",
  "Big Cursor": "Stor peker",
  "Increase Font Size": "Øk skriftstørrelsen",
  "Decrease Font Size": "Reduser skriftstørrelsen",
  "Letter Spacing": "Bokstavavstand",
  "Line Height": "Linjehøyde",
  "Font Weight": "Skriftvekt",
  "Dyslexia Font": "Dysleksisk skrifttype",
  "Language": "Språk",
  "Open Accessibility Menu": "Åpne tilgjengelighetsmeny",
  "Widget Settings": "Widget-innstillinger",
  "Widget Position": "Widget-posisjon",
  "Top Left": "Øverst til venstre",
  "Top Center": "Øverst i midten",
  "Top Right": "Øverst til høyre",
  "Center Left": "Midten til venstre",
  "Center Right": "Midten til høyre",
  "Bottom Left": "Nederst til venstre",
  "Bottom Center": "Nederst i midten",
  "Bottom Right": "Nederst til høyre",
  "Screen Reader": "Skjermleser",
  "Voice Navigation": "Talestyring",
  "Custom Color": "Egendefinert farge",
  "Change the site's colors": "Endre nettstedets farger",
  "Backgrounds": "Bakgrunner",
  "Headings": "Overskrifter",
  "Contents": "Innhold",
  "Reset colors": "Tilbakestill farger",
  "Image Desaturation": "Avmettning av bilde",
  "Search languages": "Søk etter språk",
  "No languages found": "Ingen språk funnet",
  "Accessibility Profiles": "Tilgjengelighetsprofiler",
  "Motor Impaired": "Motorisk funksjonsnedsettelse",
  "Big cursor, voice navigation, and no animations.": "Stor markør, stemmestyring og ingen animasjoner.",
  "Blind": "Blind",
  "Screen reader helpers with higher contrast.": "Skjermleser-hjelpere med høyere kontrast.",
  "Color Blind": "Fargeblind",
  "High contrast palette with desaturated media.": "Palett med høy kontrast og dempede medier.",
  "Dyslexia": "Dysleksi",
  "Friendly font, extra spacing, stronger weight.": "Lesbar font, ekstra avstand og kraftigere skrift.",
  "Low vision": "Svaksynt",
  "Dark contrast and 130% magnification.": "Mørk kontrast og 130 % forstørrelse.",
  "Cognitive & Learning": "Kognitivt og læring",
  "Highlights key sections and enables voice help.": "Fremhever viktige seksjoner og aktiverer stemmehjelp.",
  "Seizure & Epileptic": "Anfall og epilepsi",
  "Stops animations and desaturates imagery.": "Stopper animasjoner og demper bilder.",
  "ADHD": "ADHD",
  "Reading guide, highlighted links, calmer palette.": "Leseguide, uthevede lenker og roligere farger.",
  "Widget Size": "Widget Size",
  "Default": "Default",
  "Medium": "Medium",
  "Small": "Small",
  "Color Blindness": "Color Blindness",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Achromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simulates and assists users with color vision deficiencies."
}
